export enum PaymentMethodType {
  Transfer = 'transfer',
  Cash = 'cash',
}
